export default {
  dashboard: '仪表盘',
  system: '系统管理',
  user: '用户管理',
  role: '角色管理',
  profile: '个人中心',
  orderCenter: '订单中心',
  orderManagement: '订单管理',
  orderDetail: '订单详情',
  inquiryManagement: '询价管理',
  freightRateQuery: '运价查询',
  userCenter: '用户中心',
  userProfile: '个人资料',
  userManagement: '用户管理',
  roleManagement: '角色管理',
  staffManagement: '员工管理',
  positionManagement: '岗位管理',
  companyCenter: '公司管理',
  companyProfile: '公司资料',
  companyDataManagement: '企业数据管理',
  companyCertification: '企业认证管理',
  basicDataCenter: '基础资料维护',
  portManagement: '港口管理',
  carrierManagement: '船公司管理',
  routeManagement: '航线管理',
  containerManagement: '货柜管理',
  chargeManagement: '费用项管理',
  shipAgentManagement: '船代管理',
  terminalManagement: '码头管理',
  productMaterialData: '产品物料数据',
  overseasWarehouseManagement: '仓库管理',
  countryRegionManagement: '国家地区管理',
  chinaAdministrativeDivision: '行政区划',
  zipcodeManagement: '邮编管理',
  shipDataManagement: '船舶数据管理',
  tradeTermsManagement: '贸易条款管理',
  transportTermsManagement: '运输条款管理',
  calculationUnitManagement: '计算单位管理',
  packageUnitManagement: '包装单位管理',
  superRateSystem: '超级运价系统',
  blAdditionCenter: '补料中心',
  controlTowerPanel: '控制塔面板',
  rateManagement: '运价维护',
  fclRateManagement: 'FCL整箱运价',
  preportRateManagement: '港前运价',
  lastmileRateManagement: '尾程运价',
  settlement: '结算',
  settlementStatement: '结算账单'
}
